import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule, HashLocationStrategy, LocationStrategy} from '@angular/common';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {AppLayoutModule} from './layout/app.layout.module';
import {DashboardComponent} from "./components/dashboard/dashboard.component";
import {DashboardModule} from "./components/dashboard/dashboard.module";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {ErrorInterceptor} from "./interceptors/error.interceptor";
import {GoogleMapsModule} from "@angular/google-maps";
import {DropdownModule} from "primeng/dropdown";
import {SidebarModule} from 'primeng/sidebar';
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {ToastModule} from "primeng/toast";
import {ButtonModule} from "primeng/button";
import {FullCalendarModule} from "@fullcalendar/angular";
import {MenuModule} from "primeng/menu";
import {InputTextareaModule} from "primeng/inputtextarea";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ScrollPanelModule} from "primeng/scrollpanel";
import {ImageModule} from "primeng/image";
import {ConfirmPopupModule} from "primeng/confirmpopup";
import {SelectButtonModule} from "primeng/selectbutton";
import {BreadcrumbModule} from "primeng/breadcrumb";
import {PanelMenuModule} from "primeng/panelmenu";
import {MegaMenuModule} from "primeng/megamenu";
import {RippleModule} from "primeng/ripple";
import {GalleriaModule} from "primeng/galleria";
import {TabMenuModule} from "primeng/tabmenu";
import {TimelineModule} from "primeng/timeline";
import {TreeTableModule} from "primeng/treetable";
import {PaginatorModule} from "primeng/paginator";
import {TagModule} from "primeng/tag";
import {AvatarModule} from "primeng/avatar";
import {ChartModule} from "primeng/chart";
import {InputSwitchModule} from "primeng/inputswitch";
import {TreeModule} from "primeng/tree";
import {InplaceModule} from "primeng/inplace";
import {PanelModule} from "primeng/panel";
import {PickListModule} from "primeng/picklist";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {ListboxModule} from "primeng/listbox";
import {TableModule} from "primeng/table";
import {CardModule} from "primeng/card";
import {ChipsModule} from "primeng/chips";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {SliderModule} from "primeng/slider";
import {AccordionModule} from "primeng/accordion";
import {ChipModule} from "primeng/chip";
import {PasswordModule} from "primeng/password";
import {TerminalModule} from "primeng/terminal";
import {MultiSelectModule} from "primeng/multiselect";
import {DividerModule} from "primeng/divider";
import {MessagesModule} from "primeng/messages";
import {RadioButtonModule} from "primeng/radiobutton";
import {KeyFilterModule} from "primeng/keyfilter";
import {ToolbarModule} from "primeng/toolbar";
import {KnobModule} from "primeng/knob";
import {SkeletonModule} from "primeng/skeleton";
import {AutoCompleteModule} from "primeng/autocomplete";
import {FileUploadModule} from "primeng/fileupload";
import {TieredMenuModule} from "primeng/tieredmenu";
import {ToggleButtonModule} from "primeng/togglebutton";
import {CascadeSelectModule} from "primeng/cascadeselect";
import {ContextMenuModule} from "primeng/contextmenu";
import {SlideMenuModule} from "primeng/slidemenu";
import {MenubarModule} from "primeng/menubar";
import {ProgressBarModule} from "primeng/progressbar";
import {ColorPickerModule} from "primeng/colorpicker";
import {CalendarModule} from "primeng/calendar";
import {DataViewModule} from "primeng/dataview";
import {InputMaskModule} from "primeng/inputmask";
import {InputNumberModule} from "primeng/inputnumber";
import {OverlayPanelModule} from "primeng/overlaypanel";
import {TooltipModule} from "primeng/tooltip";
import {CheckboxModule} from "primeng/checkbox";
import {StepsModule} from "primeng/steps";
import {CarouselModule} from "primeng/carousel";
import {SplitterModule} from "primeng/splitter";
import {TabViewModule} from "primeng/tabview";
import {OrderListModule} from "primeng/orderlist";
import {VirtualScrollerModule} from "primeng/virtualscroller";
import {FieldsetModule} from "primeng/fieldset";
import {InputTextModule} from "primeng/inputtext";
import {BadgeModule} from "primeng/badge";
import {BrowserModule} from "@angular/platform-browser";
import {AvatarGroupModule} from "primeng/avatargroup";
import {RatingModule} from "primeng/rating";
import {ScrollTopModule} from "primeng/scrolltop";
import {MessageModule} from "primeng/message";
import {OrganizationChartModule} from "primeng/organizationchart";
import {SplitButtonModule} from "primeng/splitbutton";
import {DialogModule} from "primeng/dialog";
import {AppConfigModule} from "./layout/config/app.config.module";
import {RegisterPersonalComponent} from "./components/auth/register-personal/register-personal.component";
import {RegisterDocumentComponent} from "./components/auth/register-document/register-document.component";
import { PropertyWelcomeComponent } from './components/property-registration/property-welcome/property-welcome.component';
import { PropertyStartComponent } from './components/property-registration/property-start/property-start.component';
import { PropertyAddressComponent } from './components/property-registration/property-address/property-address.component';
import {PageNavigationBarComponent} from "./shared/components/page-navigation-bar/page-navigation-bar.component";
import {
    PropertySegmentsComponent
} from "./components/property-registration/property-segments/property-segments.component";
import {
    SimpleResponsiveFrameComponent
} from "./shared/components/simple-responsive-frame/simple-responsive-frame.component";
import {PropertyMapsComponent} from "./components/property-registration/property-maps/property-maps.component";
import {PropertyAdComponent} from "./components/property-registration/property-ad/property-ad.component";
import { PropertyListComponent } from './components/property-list/property-list.component';
import { PropertyDetailComponent } from './components/property-detail/property-detail.component';
import {AuthInterceptor} from "./interceptors/auth-interceptor";
import { PropertyNicknameComponent } from './components/property-registration/property-nickname/property-nickname.component';
import { PropertySecondComponent } from './components/property-registration/property-second/property-second.component';
import { PropertyPapersComponent } from './components/property-registration/property-papers/property-papers.component';
import { PropertyDetailsPrimaryComponent } from './components/property-registration/property-details-primary/property-details-primary.component';
import { PropertyDetailsSecondaryComponent } from './components/property-registration/property-details-secondary/property-details-secondary.component';
import {MessageService} from "primeng/api";
import {CorsInterceptor} from "./interceptors/cors.interceptor";
import { PropertyPicturesComponent } from './components/property-registration/property-pictures/property-pictures.component';
import { PropertyPicturesReviewsComponent } from './components/property-registration/property-pictures-reviews/property-pictures-reviews.component';
import { PropertyTagsComponent } from './components/property-registration/property-tags/property-tags.component';
import { PropertyThirdComponent } from './components/property-registration/property-third/property-third.component';
import { PropertyPriceComponent } from './components/property-registration/property-price/property-price.component';
import { PropertySearchListComponent } from './components/property-search-list/property-search-list.component';
import { PropertyMarketplaceComponent } from './components/property-marketplace/property-marketplace.component';
import { PropertiesComponent } from './components/properties/properties.component';
import {CustomCardComponent} from "./shared/components/custom-card/custom-card.component";
import {FiltersComponent} from "./shared/components/filters/filters.component";
import {MenuPropertyComponent} from "./shared/components/menu-property/menu-property.component";
import { PropertySuccessComponent } from './components/property-registration/property-success/property-success.component';
import { PropertyReviewComponent } from './components/property-registration/property-review/property-review.component';
import { PropertyListPendingComponent } from './components/property-list-pending/property-list-pending.component';
import { ImageGalleryComponent } from './components/property-detail/image-gallery/image-gallery.component';
import { PropertyInfoComponent } from './components/property-detail/property-info/property-info.component';
import { PropertyActionsComponent } from './components/property-detail/property-actions/property-actions.component';
import { PropertySummaryComponent } from './components/property-detail/property-summary/property-summary.component';
import { PropertyFeaturesComponent } from './components/property-detail/property-features/property-features.component';
import { PropertyLocationComponent } from './components/property-detail/property-location/property-location.component';
import { PropertyDocumentsComponent } from './components/property-detail/property-documents/property-documents.component';
import { ImageCarouselDialogComponent } from './components/property-detail/image-carousel-dialog/image-carousel-dialog.component';
import { RelatedPropertiesComponent } from './components/property-detail/related-properties/related-properties.component';
import { PropertyCardComponent } from './shared/components/property-card/property-card.component';
import { MatDialogModule } from '@angular/material/dialog';
import {MatIconModule} from "@angular/material/icon";
import { ZonePriceMapDialogComponent } from './components/property-registration/zone-price-map-dialog/zone-price-map-dialog.component';

@NgModule({
    declarations: [
        AppComponent,
        DashboardComponent,
        RegisterPersonalComponent,
        RegisterDocumentComponent,
        PropertyWelcomeComponent,
        PropertyStartComponent,
        PropertySegmentsComponent,
        PropertyAddressComponent,
        PropertyMapsComponent,
        PropertyAdComponent,
        PropertyListComponent,
        PropertyDetailComponent,
        PropertyNicknameComponent,
        PropertySecondComponent,
        PropertyPapersComponent,
        PropertyDetailsPrimaryComponent,
        PropertyDetailsSecondaryComponent,
        PropertyPicturesComponent,
        PropertyPicturesReviewsComponent,
        PropertyTagsComponent,
        PropertyThirdComponent,
        PropertyPriceComponent,
        PropertySearchListComponent,
        PropertyMarketplaceComponent,
        PropertiesComponent,
        PropertySuccessComponent,
        PropertyReviewComponent,
        PropertyListPendingComponent,
        ImageGalleryComponent,
        PropertyInfoComponent,
        PropertyActionsComponent,
        PropertySummaryComponent,
        PropertyFeaturesComponent,
        PropertyLocationComponent,
        PropertyDocumentsComponent,
        ImageCarouselDialogComponent,
        RelatedPropertiesComponent,
        ZonePriceMapDialogComponent
    ],
    imports: [
        MatDialogModule,
        AppRoutingModule,
        AppLayoutModule,
        DashboardModule,
        GoogleMapsModule,
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        AccordionModule,
        AutoCompleteModule,
        AvatarGroupModule,
        AvatarModule,
        BadgeModule,
        BreadcrumbModule,
        ButtonModule,
        CalendarModule,
        CardModule,
        CarouselModule,
        CascadeSelectModule,
        ChartModule,
        CheckboxModule,
        ChipModule,
        ChipsModule,
        CommonModule,
        ConfirmDialogModule,
        ConfirmPopupModule,
        ColorPickerModule,
        ContextMenuModule,
        DataViewModule,
        DialogModule,
        DividerModule,
        DropdownModule,
        FieldsetModule,
        FileUploadModule,
        FullCalendarModule,
        GalleriaModule,
        ImageModule,
        InplaceModule,
        InputNumberModule,
        InputMaskModule,
        InputSwitchModule,
        InputTextModule,
        InputTextareaModule,
        KnobModule,
        ListboxModule,
        MegaMenuModule,
        MenuModule,
        MenubarModule,
        MessageModule,
        MessagesModule,
        MultiSelectModule,
        OrderListModule,
        OrganizationChartModule,
        OverlayPanelModule,
        PaginatorModule,
        PanelModule,
        PanelMenuModule,
        PasswordModule,
        PickListModule,
        ProgressBarModule,
        RadioButtonModule,
        RatingModule,
        RippleModule,
        ScrollPanelModule,
        ScrollTopModule,
        SelectButtonModule,
        SidebarModule,
        SkeletonModule,
        SlideMenuModule,
        SliderModule,
        SplitButtonModule,
        SplitterModule,
        StepsModule,
        TableModule,
        TabMenuModule,
        TabViewModule,
        TagModule,
        TerminalModule,
        TieredMenuModule,
        TimelineModule,
        ToastModule,
        ToggleButtonModule,
        ToolbarModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
        VirtualScrollerModule,
        ReactiveFormsModule,
        KeyFilterModule,
        SidebarModule,
        SidebarModule,
        DropdownModule,
        ProgressSpinnerModule,
        ProgressBarModule,
        AppConfigModule,
        PageNavigationBarComponent,
        SimpleResponsiveFrameComponent,
        CustomCardComponent,
        FiltersComponent,
        MenuPropertyComponent,
        PropertyCardComponent,
        MatIconModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        {provide: LocationStrategy, useClass: HashLocationStrategy},
        {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}, // Agrega el AuthInterceptor
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CorsInterceptor,
            multi: true, // Permite registrar múltiples interceptores
        },
        MessageService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
